import React, { Component } from 'react';

import "../style/TopBar.css";

// TopBar Component
class TopBar extends Component {
  render() {
    return(
        <div className="app-header">
            <div className="page-icon">
              <i className={`${this.props.icon} gradient-icon-blue`}></i>
            </div>
            <div className="page-title">
              {this.props.title} 
              <div className="page-title-subheading">
                {this.props.subheading}
              </div>
            </div>
        </div>
    );
  }
}
export default TopBar;



// WEBPACK FOOTER //
// ./src/components/TopBar.js